import React, { useState } from 'react';
import { CellRendererParams } from 'routes/BudgetModule/config/types';
import { IconButton, styled } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import UpdateIcon from '@mui/icons-material/Edit';
import Flex from 'ui/Flex/Flex';
import { TRACKABLE_EVENTS, trackEventBudget } from 'helpers/trackerHelpers';
import { Project } from 'routes/BudgetModule/shared/useGetProjects';
import DeleteProjectModal from '../ProjectsModals/DeleteProjectModal';
import { EditProjectModal } from '../ProjectsModals/EditProjectModal';

const StyIconButton = styled(IconButton, {
    name: 'StyIconButton',
})(({ theme }) => ({
    margin: '2px',
    padding: '1.5px',
    color: theme.palette.primary.main,
}));

export default function ActionsCellRenderer({
    value,
    existingProjectsNames,
}: CellRendererParams<Project> & {
    existingProjectsNames: string[];
}): React.ReactElement | null {
    const [isDeleteProjectModalOpen, setIsDeleteProjectModalOpen] =
        useState(false);
    const [isEditProjectModalOpen, setIsEditProjectModalOpen] = useState(false);

    const onClickEdit = () => {
        trackEventBudget(TRACKABLE_EVENTS.budget.settings.projects.patch);
        setIsEditProjectModalOpen(true);
    };

    const onClickDelete = () => {
        trackEventBudget(TRACKABLE_EVENTS.budget.settings.projects.delete);
        setIsDeleteProjectModalOpen(true);
    };

    if (!value || !('id' in value)) return null;
    return (
        <>
            <Flex align="center" justify="center" alignItems="center">
                <StyIconButton size="small" onClick={onClickEdit}>
                    <UpdateIcon />
                </StyIconButton>
                <StyIconButton size="small" onClick={onClickDelete}>
                    <DeleteIcon />
                </StyIconButton>
            </Flex>
            {isDeleteProjectModalOpen && (
                <DeleteProjectModal
                    isOpen={isDeleteProjectModalOpen}
                    onClose={() => setIsDeleteProjectModalOpen(false)}
                    projectId={value.id!}
                    inscriptionsCount={value.inscriptionsCount}
                />
            )}
            <EditProjectModal
                show={isEditProjectModalOpen}
                onClose={() => setIsEditProjectModalOpen(false)}
                project={value}
                existingProjectsNames={existingProjectsNames}
            />
        </>
    );
}
